/**
 * This file "mocks" this library's api. Over time if the api
 * changes, this file may need to change as well.
 */
import * as Cookies from 'js-cookie'
import configment from '@adc/configment'
import * as constants from '@adc/constants'
import { helpers } from '@adc/core-utils'
import {
  haveMetrics,
  doneFlushing,
  createPayload,
  xhr,
  initialize as commonInitialize,
  createInstrumentFn,
} from './common'

const noop = () => undefined

const initialize = () => {
  if (!configment.get('INSTRUMENT_ENABLE', true)) return

  commonInitialize({ url: '/apps/instrument' })

  // If this is available, we force flush before unloading. this is preferred to window.unload and the like, and is
  // supported on everything but IE -- because of course it is.
  document.addEventListener(
    'visibilitychange',
    function attemptToPersistMetrics() {
      if (!haveMetrics()) return

      if (document.visibilityState === 'hidden') {
        'sendBeacon' in navigator
          ? persistMetrics.beacon()
          : persistMetrics.xhr()
      }
    }
  )
}

const persistMetrics = {
  xhr,

  beacon: () => {
    try {
      const payload = createPayload()
      if (payload) {
        const data = JSON.stringify({
          ...payload,
          [constants.cookies.XSRF_COOKIE]: Cookies.get(
            constants.cookies.XSRF_COOKIE
          ),
        })

        navigator.sendBeacon(
          '/apps/instrument',
          new Blob([data], { type: 'application/json' })
        )
      }
    } finally {
      doneFlushing()
    }
  },
}

const instrument = createInstrumentFn(initialize)

instrument.domainEvent = (
  originalImplementation => domainEvent =>
    originalImplementation({
      ...domainEvent,
      anonymoussessionid: Cookies.get(
        constants.cookies.ANONYMOUS_SESSION_COOKIE
      ),
    })
)(instrument.domainEvent)

const dataDog = {
  gauge: noop,
  reset: noop,
  debug: noop,
  initTracer: noop,
  client: noop,

  // @deprecated - use initialize instead
  init: initialize,
  initialize,
}
const instrumentFunction = (...args) => instrument(...args)
const instrumentPromise = (...args) => instrument(...args)
const middleware = (req, res, next) => {
  next()
}

if (helpers.environments.isBrowser) {
  initialize()
}

export default instrument
